import { ExpandOutline18Icon } from "@vygruppen/spor-icon-react";
import { MuteHistoryEntry } from "api/dropsLocalStorage";
import { MeasureCardHeaderLabel } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/MeasureCardHeaderLabel";
import { MuteDialog } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/MuteDialog";
import { Dispatch, FC, SetStateAction } from "react";
import { Flex, IconButton } from "shared/components/Spor";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { Semantics } from "shared/utils/semantics";

type MeasureCardHeaderProps = {
  information: CombinedHistoryResponse;
  setCompact: Dispatch<SetStateAction<boolean>>;
  isMuted: boolean;
  addMuteHistoryEntry: (entry: MuteHistoryEntry) => void;
  isMuteToggleable: boolean;
  semantics: Semantics;
};

export const MeasureCardHeader: FC<MeasureCardHeaderProps> = ({
  information,
  setCompact,
  isMuted,
  addMuteHistoryEntry,
  isMuteToggleable,
  semantics,
}) => (
  <Flex gap={1} justifyContent="space-between">
    <MeasureCardHeaderLabel information={information} />

    <Flex alignItems="flex-start" gap={1}>
      <IconButton
        variant="tertiary"
        size="xs"
        icon={<ExpandOutline18Icon />}
        className="expand-contract-button"
        onClick={(e) => {
          e.stopPropagation();
          setCompact((c) => !c);
        }}
      />

      {isMuteToggleable && (
        <Flex onClick={(e) => e.stopPropagation()}>
          <MuteDialog
            information={information}
            isMuted={isMuted}
            addMuteHistoryEntry={addMuteHistoryEntry}
            semantics={semantics}
          />
        </Flex>
      )}
    </Flex>
  </Flex>
);
